export function buildProductShareUrl(productId) {
    if (typeof window === "undefined" || productId == null) {
        return "";
    }
    const base = window.location.origin.replace(/\/$/, "");
    return `${base}/product/${productId}`;
}

/**
 * Share payload: human-readable text first, then the URL on the next line.
 */
export function formatShareText({ title, url }) {
    const safeTitle = (title || "").trim();
    const safeUrl = (url || "").trim();
    if (!safeUrl) {
        return safeTitle;
    }
    if (!safeTitle) {
        return safeUrl;
    }
    return `${safeTitle}\n${safeUrl}`;
}

/** @deprecated Prefer {@link formatShareText} */
export function formatProductShareText({ title, url }) {
    return formatShareText({ title, url });
}

/**
 * Share a title and link. Uses the native share sheet when available,
 * otherwise copies "title + newline + url" to the clipboard.
 *
 * @returns {"shared"|"copied"|"cancelled"}
 */
export async function shareContent({ title, url }) {
    const text = formatShareText({ title, url });
    if (!text) {
        throw new Error("Rien à partager");
    }

    if (typeof navigator.share === "function") {
        try {
            await navigator.share({
                title: title || undefined,
                text
            });
            return "shared";
        } catch (err) {
            if (err?.name === "AbortError") {
                return "cancelled";
            }
        }
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return "copied";
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
        if (!document.execCommand("copy")) {
            throw new Error("copy failed");
        }
        return "copied";
    } finally {
        textarea.remove();
    }
}

/**
 * @returns {"shared"|"copied"|"cancelled"}
 */
export async function shareProduct({ title, url }) {
    return shareContent({ title, url });
}
